'use client'
import {
  minifyGqlQuery
} from "./chunk-SQE4KWHX.mjs";
import {
  getWebSectionQuery
} from "./chunk-ZYT27J35.mjs";
import {
  THEME_QUERY
} from "./chunk-X74FHHFA.mjs";
import {
  SEO_QUERY
} from "./chunk-W3K3QG4J.mjs";
import {
  FOOTER_QUERY
} from "./chunk-5PELS77M.mjs";
import {
  HEADER_QUERY
} from "./chunk-WQ643R7Q.mjs";
import {
  LINK_QUERY
} from "./chunk-Y5YNZ765.mjs";
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";
import {
  SECTIONS_CONTENT_LIMIT,
  SECTIONS_LIMIT
} from "./chunk-UAMS6QZK.mjs";
import {
  getContentfulSafeLocale
} from "./chunk-IIMDQLWJ.mjs";
import {
  gqlClient
} from "./chunk-4T365VQK.mjs";
import {
  __async,
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/api/page/listing.ts
import { gql } from "graphql-request";
import { useInfiniteQuery } from "@tanstack/react-query";
import { Exception } from "@wbk/logger";
var PAGE_BASE_QUERY = gql`
  query getPageBase($lang: String, $limit: Int, $skip: Int, $where: WebPageFilter) {
    webPageCollection(locale: $lang, limit: $limit, skip: $skip, where: $where) {
       items {
        id
        title
        subtitle
        logo { ${IMAGE_QUERY} }
        slug
        theme { ${THEME_QUERY} }
        categoryFilter { id title slug }
        background { ${IMAGE_QUERY} }
        seo { ${SEO_QUERY} }
        web {
          title
          logo {${IMAGE_QUERY}}
          miniLogo {${IMAGE_QUERY}}
          header {${HEADER_QUERY}}
          footer {${FOOTER_QUERY}}
          socialLinks {
            title
            iconLinksCollection {
              items {${LINK_QUERY}}
            }
          }
        }
      }
    }
  }
`;
var buildPageSectionsQuery = ({
  sectionLimit = SECTIONS_LIMIT,
  sectionSkip = 0,
  contentLimit = SECTIONS_CONTENT_LIMIT
}) => gql`
  query getPageSections($lang: String, $where: WebPageFilter) {
    webPageCollection(locale: $lang, limit: 1, skip: 0, where: $where) {
      items {
        sectionsCollection(limit: ${sectionLimit}, skip: ${sectionSkip}) {
          items {
            __typename
            ... on WebSection {
              ${getWebSectionQuery({ contentLimit })}
            }
          }
        }
      }
    }
  }
`;
var getPage = (_a) => __async(null, null, function* () {
  var _b = _a, { lang = "en", sectionLimit, sectionSkip = 0 } = _b, props = __objRest(_b, ["lang", "sectionLimit", "sectionSkip"]);
  try {
    const locale = getContentfulSafeLocale(lang);
    if (sectionSkip === 0) {
      const baseRes = yield gqlClient.request(minifyGqlQuery(PAGE_BASE_QUERY), __spreadProps(__spreadValues({}, props), {
        lang: locale,
        limit: 1,
        skip: 0
      }));
      const sectionsRes = yield gqlClient.request(
        minifyGqlQuery(
          buildPageSectionsQuery({
            sectionLimit,
            sectionSkip: 0
          })
        ),
        __spreadProps(__spreadValues({}, props), {
          lang: locale
        })
      );
      const base = baseRes.webPageCollection.items[0];
      const sections = sectionsRes.webPageCollection.items[0];
      if (!base) return null;
      return __spreadProps(__spreadValues({}, base), {
        sectionsCollection: (sections == null ? void 0 : sections.sectionsCollection) || { items: [] }
      });
    }
    const sectionsOnly = yield gqlClient.request(
      minifyGqlQuery(
        buildPageSectionsQuery({
          sectionLimit,
          sectionSkip
        })
      ),
      __spreadProps(__spreadValues({}, props), {
        lang: locale
      })
    );
    return sectionsOnly.webPageCollection.items[0] || null;
  } catch (error) {
    throw new Exception({ error, name: "getPageException" });
  }
});
var usePage = (props, options) => {
  return useInfiniteQuery(__spreadProps(__spreadValues({
    queryKey: ["page", props],
    queryFn: ({ pageParam }) => getPage(__spreadProps(__spreadValues({}, props), {
      sectionSkip: pageParam,
      sectionLimit: props.sectionLimit
    })),
    getNextPageParam: (lastPage, allPages) => {
      var _a;
      const lastPageSections = ((_a = lastPage == null ? void 0 : lastPage.sectionsCollection) == null ? void 0 : _a.items) || [];
      const limit = props.sectionLimit || SECTIONS_LIMIT;
      return lastPageSections.length === limit ? allPages.length * limit : void 0;
    },
    initialPageParam: (options == null ? void 0 : options.initialPageParam) || 0
  }, options), {
    select(data) {
      const page = data.pages[0];
      const sections = data.pages.flatMap((page2) => {
        var _a;
        return ((_a = page2 == null ? void 0 : page2.sectionsCollection) == null ? void 0 : _a.items) || [];
      });
      return __spreadProps(__spreadValues({}, page), {
        sectionsCollection: { items: sections }
      });
    }
  }));
};

export {
  buildPageSectionsQuery,
  usePage
};
//# sourceMappingURL=chunk-YX5SWSIR.mjs.map